import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api, { mediaSrc } from "../lib/api";
import { VerifiedBadge } from "./VerifiedBadge";
import { BadgeCheck } from "lucide-react";

export function VerifiedSpotlight() {
  const [users, setUsers] = useState(null);
  useEffect(() => {
    api.get("/spotlight/verified", { params: { limit: 8 } }).then(({ data }) => setUsers(data)).catch(() => setUsers([]));
  }, []);
  if (!users || users.length === 0) return null;
  return (
    <section className="mb-8" data-testid="verified-spotlight">
      <div className="flex items-center gap-2 mb-3">
        <BadgeCheck size={18} className="text-[#0066FF]" fill="#0066FF" stroke="#fff" />
        <h2 className="text-white font-heading text-lg tracking-tight">Verified archivists</h2>
      </div>
      <div className="flex gap-3 overflow-x-auto no-scrollbar pb-1">
        {users.map((u) => (
          <Link key={u.id} to={`/u/${u.username}`} data-testid={`spotlight-${u.username}`}
            className="shrink-0 w-44 bg-[#182132] border border-white/10 rounded-xl overflow-hidden hover:border-[#0066FF]/40 transition-colors">
            <div className="grid grid-cols-2 gap-0.5 h-24 bg-[#0B101D]">
              {u.thumbs.slice(0, 4).map((t, i) => (
                <img key={i} src={mediaSrc(t)} alt="" className="w-full h-full object-cover" />
              ))}
            </div>
            <div className="p-3">
              <p className="flex items-center gap-1 text-white text-sm font-semibold"><span className="truncate">{u.display_name}</span><VerifiedBadge show size={13} /></p>
              <p className="text-[#64748B] text-xs truncate">@{u.username} · {u.post_count} post{u.post_count === 1 ? "" : "s"}</p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}
